import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Box, Fab } from '@mui/material';
import Iconify from './Iconify';

Incrementer.propTypes = {
  disabledIncrementer: PropTypes.bool,
  disabledDecrementer: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
};

Incrementer.defaultProps = {
  disabledIncrementer: false,
  disabledDecrementer: false,
  max: 10,
  min: 0,
  value: 0,
  onChange: () => {},
};

function Incrementer({
  disabledIncrementer,
  disabledDecrementer,
  max,
  min,
  value,
  onChange,
}) {
  const [quantity, setQuantity] = useState(value);
  return (
    <Box
      sx={{
        'lineHeight': 0,
        'display': 'flex',
        'alignItems': 'center',
        '& .MuiFab-root': {
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.primary.palette[100]
              : theme.palette.primary.palette[300],
        },
        '& .Mui-disabled': {
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[50]
              : theme.palette.grey[800],
        },
      }}
    >
      <Fab
        size="small"
        color="inherit"
        disabled={disabledDecrementer || quantity <= min}
        onClick={() => {
          const newQuantity = quantity - 1;
          setQuantity(newQuantity);
          onChange(newQuantity);
        }}
        sx={{
          'width': '24px',
          'height': '24px',
          'minHeight': '24px',
          'zIndex': 0,
          '&.Mui-disabled': {
            backgroundColor: (theme) => theme.palette.grey[50],
          },
          '&.MuiFab-root': {
            '&:hover': {
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.primary.palette[100]
                  : theme.palette.primary.palette[300],
            },
          },
        }}
      >
        <Iconify icon={'eva:minus-fill'} width={14} height={14} />
      </Fab>

      <Typography
        variant="body3"
        component="span"
        sx={{ width: 40, textAlign: 'center', fontSize: '20px' }}
      >
        {quantity}
      </Typography>

      <Fab
        size="small"
        color="inherit"
        disabled={disabledIncrementer ? true : quantity >= max}
        onClick={() => {
          const newQuantity = quantity + 1;
          setQuantity(newQuantity);
          onChange(newQuantity);
        }}
        sx={{
          'width': '24px',
          'height': '24px',
          'minHeight': '24px',
          'zIndex': 0,
          '&.Mui-disabled': {
            backgroundColor: (theme) => theme.palette.grey[50],
          },
          '&.MuiFab-root': {
            '&:hover': {
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.primary.palette[100]
                  : theme.palette.primary.palette[300],
            },
          },
        }}
      >
        <Iconify icon={'eva:plus-fill'} width={14} height={14} />
      </Fab>
    </Box>
  );
}

export default Incrementer;
